
export interface TableColProps {
	name: string;
	title: string;
	width?: string;
	align?: 'left' | 'center' | 'right'
}

export const MetaColsAll: TableColProps[] = [
	{ name: "serviceCode", title: "SERVICE CODE", width: "20%" },
	{ name: "name", title: "NAME", width: "20%" },
	{ name: "alias", title: "ALIAS", width: "20%" },
	{ name: "description", title: "FULL DESCRIPTION", width: "45%" },
	{ name: "desc2", title: "DESCRIPTION", width: "40%" },

	{ name: "target", title: "TARGET", width: "100px", align: "center" },
	{ name: "group", title: "GROUP", width: "130px", align: "center" },
	{ name: "graph", title: "GRAPH", width: "100px", align: "center" },
	{ name: "tag", title: "TAG", width: "100px" },
	{ name: "recipe", title: "RECIPE", width: "100px" },

	{ name: "type", title: "TYPE", width: "100px", align: "center" },
	{ name: "format", title: "FORMAT", width: "100px" },
	{ name: "readOnly", title: "READ ONLY", width: "100px" },

	{ name: "um", title: "UM", width: "50px",  align: "right" },
	{ name: "min", title: "MIN", width: "80px", align: "right" },
	{ name: "max", title: "MAX", width: "80px", align: "right" },

	{ name: "value", title: "VALUE", width: "100px", align: "right" },
]

function getCol(name: string): TableColProps {
	return MetaColsAll.find(col => col.name == name)
}

export const MetaColsDefault: TableColProps[] = [
	getCol("serviceCode"),
	getCol("name"),
	getCol("desc2"),
	getCol("group"),
	getCol("target"),
	getCol("type"),
	getCol("value"),
]

export const MetaColsProperties: TableColProps[] = [
	getCol("name"),
	getCol("desc2"),
	getCol("type"),
	getCol("min"),
	getCol("max"),
	getCol("um"),
	getCol("value"),
]
